import { Location } from '@angular/common';
import { Component, HostBinding, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'belender-expiration-date',
  templateUrl: './expiration-date.component.html',
  styleUrls: ['./expiration-date.component.scss']
})
export class ExpirationDateComponent {
  /** Dialog mode cancels the .mat-dialog-container padding (see _help-page.scss). */
  @HostBinding('class.is-dialog') isDialog = false;

  constructor(
    private location: Location,
    @Optional() private dialogRef: MatDialogRef<ExpirationDateComponent>,
  ) {
    this.isDialog = !!this.dialogRef;
  }

  /** "Volver al formulario": closes the help dialog or, when routed, goes back in history. */
  back(event?: Event) {
    event?.preventDefault();
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.location.back();
    }
  }
}
